import { render, staticRenderFns } from "./ContestPage.vue?vue&type=template&id=70d8ad7e&scoped=true&"
import script from "./ContestPage.vue?vue&type=script&lang=js&"
export * from "./ContestPage.vue?vue&type=script&lang=js&"
import style0 from "./ContestPage.vue?vue&type=style&index=0&id=70d8ad7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8ad7e",
  null
  
)

export default component.exports